/**
 * После логина/регистрации: перенос localStorage pending + серверной гостевой корзины в user cart.
 * Продуктовая страница для гостя использует только guest API; лендинги — pending в LS.
 */
import { cartAPI } from './api';
import {
  getPendingCartItems,
  clearPendingCart,
  clearGuestSessionId,
  getExistingGuestSessionId,
} from './pendingCart';

/**
 * @returns {{ pending: {total, ok, fail}, guest: {total, ok, fail} }}
 */
export async function mergeCartsAfterAuth() {
  let pendingOk = 0;
  let pendingFail = 0;
  const pending = getPendingCartItems();

  for (const item of pending) {
    try {
      if (!item.productId) {
        pendingFail++;
        continue;
      }
      await cartAPI.addToCart(item.productId, item.calculatorData || null);
      pendingOk++;
    } catch {
      pendingFail++;
    }
  }
  if (pending.length > 0 && pendingFail === 0) {
    clearPendingCart();
  }

  let guestOk = 0;
  let guestFail = 0;
  let guestRows = [];
  const sid = getExistingGuestSessionId();
  if (sid) {
    try {
      const gr = await cartAPI.getGuestCart(sid);
      guestRows = Array.isArray(gr.items) ? gr.items : [];
    } catch {
      guestRows = [];
    }
    for (const row of guestRows) {
      try {
        await cartAPI.addToCart(row.product_id, row.calculator_data || null);
        guestOk++;
        try {
          await cartAPI.removeFromGuestCart(row.id, sid);
        } catch {
          /* очистка гостевой строки не критична */
        }
      } catch {
        guestFail++;
      }
    }
    if (guestRows.length > 0 && guestFail === 0) {
      clearGuestSessionId();
    }
  }

  return {
    pending: { total: pending.length, ok: pendingOk, fail: pendingFail },
    guest: { total: guestRows.length, ok: guestOk, fail: guestFail },
  };
}
